import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
const styles = (theme) => ({
  mainButton: {
    height: "20px",
    margin: "5px 0px",
    fontSize: "12px",
    width: "90px",
    "&$buttonDisabled": {
      borderColor: theme.iconColor,
      cursor: "not-allowed",
      color: theme.iconColor,
    },
  },
  buttonDisabled: {},
});

const StyledButton = withStyles(styles)(({ children, classes, ...other }) => (
  <Button
    classes={{
      root: classes.mainButton,
      disabled: classes.buttonDisabled,
    }}
    {...other}
  >
    {children}
  </Button>
));

export default StyledButton;
